import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import BorderBottomDotted from '@app/components/common/BorderBottomDotted/BorderBottomDotted';
import { CatHeading } from '@blocks-react/components/Heading';
import { PRODUCT_VARIANTS } from '@app/constants/commonConstants';
import ProductPrimaryActions from '@app/components/common/product/ProductPrimaryActions/ProductPrimaryActions';
import styles from './KitPartsCardsTotal.module.scss';

const KitPartsCardsTotal = ({
  quantity,
  priceCallStatus,
  partNumber,
  isPackage,
  initialPriceCallMade,
  isPackageWithItemAssociated
}) => {
  const [t] = useTranslation();
  const price = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.discountedPrice
  );
  const currency = useSelector(s => s.dealerCustomer.currency);
  const gaProductsData = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]
  );
  return (
    <div
      className={cx(
        'd-flex flex-column mt-3',
        styles['kit-part-card__total-price-container']
      )}
    >
      <div
        className={cx(
          'd-flex mb-1',
          styles['kit-part-card__total-price-heading']
        )}
      >
        <CatHeading te variant="display-sm">
          {t('PDP_KITS_KIT_TOTAL')}
        </CatHeading>
        <BorderBottomDotted className="mb-2" />
        <CatHeading variant="display-sm">{`${price} ${currency}`}</CatHeading>
      </div>
      <ProductPrimaryActions
        hideOtherInputs
        priceCallStatus={priceCallStatus}
        productId={partNumber}
        quantity={quantity}
        suppressLoader={initialPriceCallMade} // Don't show loader after first load
        isPackage={isPackage}
        isPackageWithItemAssociated={isPackageWithItemAssociated}
        selectedQuantity={quantity}
        partNumber={partNumber}
        variant={PRODUCT_VARIANTS.card}
        productClickDetails={gaProductsData}
      />
    </div>
  );
};

KitPartsCardsTotal.propTypes = {
  isPackageWithItemAssociated: PropTypes.bool,
  quantity: PropTypes.string,
  priceCallStatus: PropTypes.string,
  isPackage: PropTypes.bool,
  initialPriceCallMade: PropTypes.bool,
  partNumber: PropTypes.string
};

export default KitPartsCardsTotal;
